import { render, staticRenderFns } from "./user-view-component.vue?vue&type=template&id=0564c7f5&scoped=true&lang=pug"
import script from "./user-view-component.js?vue&type=script&lang=js&external"
export * from "./user-view-component.js?vue&type=script&lang=js&external"
import style0 from "./user-view-component.vue?vue&type=style&index=0&id=0564c7f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0564c7f5",
  null
  
)

export default component.exports